import React from "react"

export default function ShowError({ message = "Došlo je do greške prilikom učitavanja modula" }) {
  return (
    <div style={styles.container}>
      <div style={styles.box}>
        <h3 style={styles.message}>⚠️ {message}</h3>
      </div>
    </div>
  )
}

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  box: {
    textAlign: "center",
    padding: "30px 40px",
    background: "#fff",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  },
  message: {
    margin: 0,
    color: "#555",
  },
}